import BlockPadding from '@/components/block-padding';
import { Button, CtaBox as CtaBoxComponent } from '@bumble/ui-kit';
import { useRouter } from 'next/router';

import styles from './cta-box.module.scss';

export default function CtaBox({ data }: { data: any }) {
  const { heading, description, cta } = data || {};
  const router = useRouter();

  return (
    <BlockPadding maxWidth="large">
      <div className={styles.wrapper}>
        <CtaBoxComponent
          title={heading}
          description={description}
          color="default"
          align="center"
          variant="default"
        />

        {cta[0] && (
          <div className={styles.cta}>
            {cta?.map((item: any, index: number) => {
              const link = item.link.includes('http')
                ? item.link
                : `/love-stories/${router.locale}${item.link}`;

              return (
                <div key={item.text}>
                  <Button
                    href={link}
                    text={item.text}
                    isTargetBlank={item.targetBlank}
                    isInline={true}
                    designType={index !== 0 ? 'secondary' : 'primary'}
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </BlockPadding>
  );
}
